<div class="navigation row clearfix">
    <ng-container *ngIf="currentApp">
        <p *ngIf="!currentApp" class="hidden">Keine Daten vorhanden</p>
        <ng-container *ngIf="currentApp" [ngSwitch]="currentApp">
            <ng-container *ngSwitchCase="'miwap'">
                <ng-container *ngTemplateOutlet="MiwapNavigation"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'kobra'">
                <ng-container *ngTemplateOutlet="DefaultNavigation"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'horch'">
                <ng-container *ngTemplateOutlet="DefaultNavigation"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'lip'">
                <ng-container *ngTemplateOutlet="NoNavigation"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
<ng-template #MiwapNavigation>
    <!--<mat-tab-group class="miwap-navigation" animationDuration="0ms" (selectedIndexChange)="onSelectedIndexChange($event)" (selectedTabChange)="onSelectedTabChange($event)">
        <mat-tab *ngFor="let item of items">
            <ng-template mat-tab-label>
                <span  routerLink="{{item.value}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ item.name }}</span>
            </ng-template>
            <div *ngIf="item.children && item.children.length > 0" class="row">
                <div class="col-md-4 col-sm-4" *ngFor="let subItem of item.children">
                    <button routerLink="{{subItem.value}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ subItem.name }}</button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>-->
    <div *ngIf="menuLevels > 1 && !isMinimalCase" class="miwap-navigation">
        <nav mat-tab-nav-bar>
            <ng-container *ngFor="let link of items; index as i">
                <a mat-tab-link [tabIndex]="i"
                   *ngIf="!link.hide"
                   [routerLink]="link.value"
                   routerLinkActive #rla="routerLinkActive"
                   [active]="rla.isActive || isParentOrChildRouteActive(i)">
                    {{link.name}}
                </a>
            </ng-container>
        </nav>

        <div *ngFor="let link of items; index as i">
            <div *ngIf="isParentOrChildRouteActive(i)" class="tab-content">
                <div *ngIf="link.children && link.children.length > 0" class="row">
                    <div class="col-md-4 col-sm-4" *ngFor="let subItem of link.children">
                        <button routerLink="{{subItem.value}}" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{ subItem.name }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="menuLevels == 1 && !isMinimalCase" class="miwap-navigation">
        <div>
            <div class="tab-content" style="margin: 0;">
                <div class="row">
                    <div class="col-md-4 col-sm-4" *ngFor="let link of mainItems; index as i">
                        <button
                            [routerLink]="link.value"
                            routerLinkActive #rla="routerLinkActive"
                            [ngClass]="{'active' : rla.isActive}">
                            {{link.name}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isMinimalCase" class="miwap-navigation">
        <nav mat-tab-nav-bar>
            <ng-container *ngFor="let link of items; index as i">
            <a mat-tab-link [tabIndex]="i"
               *ngIf="!link.hide"
               [routerLink]="link.value"
               routerLinkActive #rla="routerLinkActive"
               [active]="rla.isActive">
                {{link.name}}
            </a>
            </ng-container>
        </nav>
        <div>
            <div class="tab-content">
                <div class="row">
                    <div class="col-md-4 col-sm-4">
                        <button
                            routerLink="/miwap/minimal-rental-price-case"
                            class="active">
                            Minimalprüfung
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--<span *ngIf="mainItems && mainItems.length > 0" class="additional-items col-md-4 col-sm-4" [ngClass]="{'active' : selectedMenuItemMain}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-form-field>
            <mat-select [(ngModel)]="selectedMenuItemMain" >
                <mat-option value="" *ngIf="getContextByUrl()">Privat genutzte Fahrzeuge</mat-option>
                <mat-option *ngFor="let item of mainItems" [value]="item.value" routerLink="{{item.value}}">
                    {{ item.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </span>
    <span class="col-md-4 col-sm-4" *ngIf="getContextByUrl()">
        <button routerLink='/miwap/commercial-vehicle-case' routerLinkActive="active">Gewerblich genutzte Fahrzeuge</button>
    </span>
    <span *ngIf="additionalItems && additionalItems.length > 0" class="additional-items col-md-4 col-sm-4" [ngClass]="{'active' : selectedMenuItem}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-form-field>
            <mat-select [(ngModel)]="selectedMenuItem" >
                <mat-option value="">Zusatzfunktionen</mat-option>
                <mat-option *ngFor="let item of additionalItems" [value]="item.value" routerLink="{{item.value}}">
                    {{ item.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </span>-->
</ng-template>
<ng-template #DefaultNavigation>
    <div class="default-navigation row">
        <ng-container  *ngFor='let item of mainItems; index as i; first as isFirst'>
            <div class="col-md-4 col-sm-4" *ngIf="item.admin === undefined || (item.admin && admin)">
                <button routerLink='{{ item.value }}' routerLinkActive="active">{{ item.name }}</button>
            </div>
        </ng-container>

        <div *ngIf="additionalItems && additionalItems.length > 0" class="additional-items col-md-4 col-sm-4"
             [ngClass]="{'active' : selectedMenuItem}">
            <mat-form-field>
                <mat-select [(ngModel)]="selectedMenuItem" (ngModelChange)="setRoute()">
                    <mat-option value="">Zusatzfunktionen</mat-option>
                    <mat-option *ngFor="let item of additionalItems" [value]="item.value">
                        {{ item.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</ng-template>
<ng-template #NoNavigation>
</ng-template>
